import React from 'react';
import { useTranslation } from 'react-i18next';
import SearchDeviants from '@wix/da-ds/pkg/Icons/24x24/SearchDeviants';
import s from './EmptyView.scss';

interface Props {}

const EmptyView: React.FC<Props> = () => {
  const { t } = useTranslation();
  return (
    <div className={s['root']}>
      <SearchDeviants disableDefaultColors className={s['icon']} />
      <div>
        {t('popup.seller.giftExclusive.emptyState.noResults', {
          postProcess: ['reactPostprocessor'],
          br: <br />,
        })}
      </div>
    </div>
  );
};
EmptyView.displayName = 'EmptyView';

export default EmptyView;
